import Authorization from '@/apps/Authorization'
import AuthRegLayout from '@/apps/layout/components/AuthRegLayout'
import React from 'react'

const AuthorizationPage = (): React.ReactElement => {
  return (
    <AuthRegLayout>
      <Authorization />
    </AuthRegLayout>
  )
}

export default AuthorizationPage
